import styled from "styled-components";
import { TransactionState } from "../../../store/billing/models/internal";
import { colours } from "../../../styles/colours";

export const Status = styled.span<{ status: TransactionState }>`
  color: ${({ status }) => {
    switch (status) {
      case "APPROVED":
        return colours.green;
      case "DECLINED":
        return colours.red;
      default:
        return colours.darkGrey;
    }
  }};
`;
